import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { decrementZoom, fitZoom, incrementZoom } from '../../actionCreators';
import Zoom from '../../components/handoff/Zoom';
import { getZoomPercentage } from '../../selectors/handoff';
function mapStateToProps(state) {
    return {
        zoom: getZoomPercentage(state),
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        incrementZoom: incrementZoom,
        decrementZoom: decrementZoom,
        fitZoom: fitZoom,
    }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(Zoom);
